import { flushSync } from "react-dom";

// Client-side navigation: the app listens for popstate, so announcing a pushed
// entry the same way renders the next route without reloading the page.
export function navigate(href: string) {
  window.history.pushState(null, "", href);
  flushSync(() => { window.dispatchEvent(new PopStateEvent("popstate")); });
  window.scrollTo({ top: 0, behavior: "instant" });
}

// Plain left clicks on same-origin app links navigate in place. Downloads,
// new tabs, modified clicks and links handled elsewhere keep native behaviour.
export function interceptLinkClick(event: MouseEvent) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = (event.target as Element | null)?.closest?.("a[href]");
  if (!(link instanceof HTMLAnchorElement) || link.hasAttribute("download") || (link.target && link.target !== "_self")) return;
  const url = new URL(link.href);
  if (url.origin !== window.location.origin || !isAppRoute(url.pathname)) return;
  if (url.pathname === window.location.pathname && url.hash) return;
  event.preventDefault();
  navigate(url.pathname + url.search + url.hash);
}

function isAppRoute(pathname: string) {
  return pathname === "/" || pathname.startsWith("/g/") || pathname.startsWith("/settings/");
}
